import React, { useEffect, useRef } from 'react';
import imagesLoaded from 'imagesloaded';
import isotope from 'isotope-layout';
import OwlCarousel from 'react-owl-carousel2';

//Import Utils
import { isotopeLoad } from "../../utils";

//Import Settings
import {
    sliderDefaultOptions,
    extraSetting1,
    extraSetting2,
    extraSetting3,
    extraSetting4,
    extraSetting5,
    events
} from "../../utils/settings";

function Carousel ( props ) {
    const { addClass = "", settings = '', isTheme = true } = props;
    const carouselRef = useRef( null );
    const initializedRef = useRef( false );
    let options = getOption( settings, addClass );
    let res = Object.assign( {}, sliderDefaultOptions, options );

    useEffect( () => {
        if ( carouselRef.current && !initializedRef.current ) {
            init();
            initializedRef.current = true;
            if ( carouselRef.current.$node && carouselRef.current.$node.closest( ".grid" ) ) {
                isotopeLoad( isotope, imagesLoaded );
            }
        }
    }, [ props.children, settings, addClass ] )

    useEffect( () => {
        if ( carouselRef.current && carouselRef.current.props.className.indexOf( 'product-single-carousel' ) > -1 ) {
            let dots;
            let carousel = carouselRef.current;
            let parent = carousel.$node.closest( '.product-single-gallery' )[ 0 ];

            // if ( parent.querySelector( "#carousel-quick-dots .owl-dot" ) ) {
            //     if ( parent.querySelector( "#carousel-quick-dots .owl-dot.active" ) ) {
            //         parent.querySelector( "#carousel-quick-dots .owl-dot.active" ).classList.remove( "active" );
            //     }

            //     parent.querySelector( "#carousel-quick-dots .owl-dot" ).classList.add( "active" );
            //     carousel.goTo( 0 );
            //     dots = parent.querySelectorAll( '#carousel-quick-dots .owl-dot' );

            //     for ( let i = 0; i < dots.length; i++ ) {
            //         dots[ i ].addEventListener( "click", ( e ) => {
            //             carousel.goTo( e.currentTarget.index() );
            //         }, true );
            //     }
            // } 
            if ( parent.querySelector( "#dots-after-thumbnail .owl-after" ) ) {
                if ( parent.querySelector( "#dots-after-thumbnail .owl-after.active" ) ) {
                    parent.querySelector( "#dots-after-thumbnail .owl-after.active" ).classList.remove( "active" );
                }

                parent.querySelector( "#dots-after-thumbnail .owl-after" ).classList.add( "active" );
                carousel.goTo( 0 );
                dots = parent.querySelectorAll( '#dots-after-thumbnail .owl-after' );

                for ( let i = 0; i < dots.length; i++ ) {
                    dots[ i ].addEventListener( "click", ( e ) => {
                        carousel.goTo( e.currentTarget.index() );
                    }, true );
                }
            }
        }
    }, [ window.location.pathname ] )

    const init = () => {
        let homeSliderSidebar = document.querySelector( '.home-slider-sidebar ul' );
        if ( homeSliderSidebar ) {
            let items = document.querySelectorAll( ".home-slider-sidebar li" );
            let carousel = carouselRef.current;
            for ( let i = 0; i < items.length; i++ ) {
                items[ i ].addEventListener( "click", ( e ) => {
                    if ( !e.currentTarget.classList.contains( 'active' ) ) {
                        carousel.goTo( e.currentTarget.index() );
                    }
                }, true );
            }
        }

        if ( carouselRef.current && carouselRef.current.props.className.indexOf( 'home-slider' ) > -1 && document.querySelector( ".home-slider-thumbs" ) ) {
            let items = document.querySelectorAll( '.home-slider-thumbs a' );
            let carousel = carouselRef.current;
            for ( let i = 0; i < items.length; i++ ) {
                items[ i ].addEventListener( "click", ( e ) => {
                    let self = e.currentTarget;
                    if ( !self.classList.contains( 'active' ) ) {
                        let index = self.index();
                        carousel.goTo( index );
                    }
                    e.preventDefault();
                }, true );
            }
        }
    }

    function getOption ( settings, addClass = '' ) {
        let options = settings;
        if ( addClass.indexOf( 'widget-featured-product' ) > -1 ) {
            options = extraSetting1;
        }
        if ( addClass.indexOf( 'post-slider' ) > -1 ) {
            options = extraSetting2;
        }
        if ( addClass.indexOf( 'product-single-carousel' ) > -1 ) {
            options = Object.assign( {}, extraSetting4, options );
        }
        if ( addClass.indexOf( 'product-quick-carousel' ) > -1 ) {
            options = extraSetting3;
        }
        if ( addClass.indexOf( 'pro-extended' ) > -1 ) {
            options = extraSetting5;
        }
        return options;
    }

    return (
        ( props.children.length > 0 || ( props.children && props.children.length === undefined ) ) ?
            <div className="carousel-reserved">
                <OwlCarousel ref={ carouselRef } className={ `owl-carousel ${isTheme ? 'owl-theme' : ''} ${addClass}` } options={ res } events={ events }>
                    { props.children }
                </OwlCarousel>
            </div>
            : ""
    );
}

function areEqual ( prevProps, nextProps ) {
    if ( window.location.href.indexOf( "products/extended/" ) > -1 ) {
        if ( prevProps.id !== nextProps.id ) {
            return false;
        }

        return true;
    }

    return false;
}

export default React.memo( Carousel, areEqual );